module.exports = __webpack_public_path__ + "img/ic-status.5a31f7dd.svg";